import apiBaseState from "~/constants/apiBaseState";
import Vueset from "~/utils/Vueset";
import moment from "moment";

const getState = () => {
    return {
        aiConversationsState: apiBaseState(),
        aiConversationMessagesState: apiBaseState(),
        createAiConversationMessageState: apiBaseState(),
        deleteAiConversationState: apiBaseState(),// not used
        updateAiConversationMessageState: apiBaseState(),
        updateAiConversationState: apiBaseState(),
        deleteAiConversationMessageState: apiBaseState(),// not used
        editAiConversationMessageState: apiBaseState(),
        createMockAiConversationState: apiBaseState(),
        evaluateAiConversationState: apiBaseState(),
        mockAiConversationData: [],
        isTaskLevel: false,
        isQuestionLevel: false,
        isVideoCall: false,
        chosenChat: null,
        questionId: null,
        questionContext: null,
        chatWindowHide: false,
        meetingRoomId: null,
        isGlobalAi: null,
        isGlobalAiQuestionId: null,
    };
};
export const state = () => (getState());

export const getters = {
    aiConversationProcessing(state){
        const checks = [
            'aiConversationsState',
            'aiConversationMessagesState',
            'createAiConversationMessageState',
            'deleteAiConversationState',
            'updateAiConversationMessageState',
            'updateAiConversationState',
            'deleteAiConversationMessageState',
            'editAiConversationMessageState',
        ];
        return checks.some(item => state[item].loading);
    },
};

export const mutations = {
    RESET_STORE(state){
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    SET_GLOBAL_AI(state, payload){
        state.isGlobalAi = payload.state;
        state.isGlobalAiQuestionId = payload.questionId;
        if (Object.prototype.hasOwnProperty.call(payload, 'question')) {
            state.questionContext = normaliseQuestionContext(payload.question);
        }
    },
    SET_AI_FOR_QUESTIONS(state, payload){
        const question = isQuestionPayload(payload) ? payload : null;
        state.questionId = question ? question.id : payload;
        state.questionContext = normaliseQuestionContext(question);
        state.isQuestionLevel = true;
        state.isTaskLevel = false;
        state.isVideoCall = false;
    },
    SET_AI_QUESTION_CONTEXT(state, question){
        state.questionContext = normaliseQuestionContext(question);
        if (question?.id) {
            state.questionId = question.id;
        }
    },
    SET_AI_FOR_VIDEO_CALLS(state, payload){
        state.questionId = payload;
        state.questionContext = null;
        state.isQuestionLevel = false;
        state.isTaskLevel = false;
        state.isVideoCall = true;
    },
    SET_AI_FOR_VIDEO_CALLS_ROOM_ID(state, id){
        state.meetingRoomId = id;
    },
    SET_CHOSEN_CHAT(state, payload){
        state.chosenChat = payload;
    },
    STREAM_TO_CHOSEN_CHAT(state, payload) {
        const { stream, tempConvId } = payload;
        const messages = state.chosenChat.messages;
        const lastIndex = messages.length - 1;

        if (stream.role === 'assistant') {

            if(tempConvId){
                const findIndex = state.aiConversationsState.data.data.findIndex(item => item.id === tempConvId);
                if (findIndex !== -1) {
                    state.aiConversationsState.data.data[findIndex].id = stream.conversation_id;
                }
            }

            // Update the ID of the new last message with parent_id
            messages[messages.length - 1].id = stream.parent_id;
            // Add the stream message
            messages.push(stream);
        }

        if (!stream.role && messages.length) {
            if (stream.replace) {
                messages[lastIndex].text = stream.text;
            } else {
                messages[lastIndex].text = `${messages[lastIndex].text || ''}${stream.text}`;
            }
        }
    },
    ADD_TO_CHOSEN_CHAT(state, payload){
        if(!state.chosenChat.messages){
            state.chosenChat.messages = [];
        }
        state.chosenChat.messages.push(payload);
    },
    UPDATE_CHOSEN_CHAT_BY_TEMP_ID(state, payload){
        const index = state.chosenChat.messages.findIndex(item => item.id === payload.tempId);
        Vueset(state.chosenChat.messages, index, {
            ...state.chosenChat.messages[index],
            id: payload.parent_id
        });
    },
    UPDATE_CHOSEN_CHAT_BY_ID(state, payload){
        const index = state.chosenChat.messages.findIndex(item => item.id === payload.id);
        Vueset(state.chosenChat.messages, index, {
            ...state.chosenChat.messages[index],
            ...payload
        });
    },
    SET_MESSAGE_UPDATE_STATUS(state, payload){
        const messageIndex = state.chosenChat.messages.findIndex(item => item.id === payload.id);
        Vueset(state.chosenChat.messages, messageIndex, {
            ...state.chosenChat.messages[messageIndex],
            update: payload.status
        });
    },
    DELETE_MESSAGES_AFTER_ID(state, payload){
        const messageIndex = state.chosenChat.messages.findIndex(item => item.id === payload.id);
        const messages = state.chosenChat.messages.slice(0, (messageIndex + 1));
        state.chosenChat.messages = messages;
    },
    DELETE_MESSAGES_AT_ID(state, payload){
        const messageIndex = state.chosenChat.messages.findIndex(item => item.id === payload.id);
        const messages = state.chosenChat.messages.slice(0, (messageIndex));
        state.chosenChat.messages = messages;
    },
    DELETE_MESSAGE_BY_ID(state, id){
        if(!state.chosenChat?.messages?.length){
            return;
        }
        const messageIndex = state.chosenChat.messages.findIndex(item => item.id === id);
        if(messageIndex > -1){
            state.chosenChat.messages.splice(messageIndex, 1);
        }
    },
    SET_AI_CONVERSATION_IS_TASK_LEVEL(state, payload){
        state.isTaskLevel = payload;
    },
    SET_AI_CONVERSATIONS(state, payload){
        if(payload.data){
            payload = {
                data: payload
            };
        }
        state.aiConversationsState = payload;
    },
    SET_CREATE_AI_CONVERSATION_MESSAGE(state, payload){
        state.createAiConversationMessageState = payload;
    },
    UPDATE_AI_CONVERSATION(state, payload){
        state.updateAiConversationMessageState = payload;
    },
    UPDATE_AI_CONVERSATION_BY_ID(state, payload){
        const index = state.aiConversationsState.data.data.findIndex(item => item.id === payload.id);
        Vueset(state.aiConversationsState.data.data, index, payload);
    },
    ADD_AI_CONVERSATION(state, payload){
        state.aiConversationsState.data.data.unshift(payload);
    },
    ADD_AI_CONVERSATION_TEMP(state, payload) {
        const { id, user } = payload;
        const tempConversation = {
            id,
            title: "New chat",
            private: false,
            model: "n/a",
            user: {
                name: user.name,
                username: user.username,
                avatar: user.avatar
            },
            created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
            editable: true,
            responses_count: null,
            messages: [],
            filters: {
                translation_language: null,
                stream: false
            }
        };
        state.chosenChat = tempConversation;
        state.aiConversationsState.data.data.unshift(tempConversation);
    },
    DELETE_AI_CONVERSATION(state, payload){
        state.deleteAiConversationState = payload;
    },
    DELETE_AI_CONVERSATION_BY_ID(state, payload){
        const index = state.aiConversationsState.data.data.findIndex(item => item.id === payload.conversationId);
        state.aiConversationsState.data.data.splice(index, 1);
    },
    SET_AI_CONVERSATION_MESSAGES(state, payload){
        state.aiConversationMessagesState = payload;
    },
    SET_AI_CONVERSATION_MESSAGES_LOADING(state, payload){
        state.aiConversationMessagesState.loading = payload;
        state.chatWindowHide = payload;
    },
    SET_UPDATE_AI_CONVERSATIONS(state, payload){
        state.updateAiConversationState = payload;
    },
    MARK_CONVERSATION_AS_UPDATING(state, payload){
        const index = state.aiConversationsState.data.data.findIndex(item => item.id === payload.id);
        Vueset(state.aiConversationsState.data.data, index, payload);

    },
    MARK_CONVERSATIONS_AS_COMPLETE(state){
        state.aiConversationsState.data.data.forEach(item => {
            item.update = null;
        });
    },
    SET_DELETE_AI_CONVERSATION_MESSAGE(state, payload){
        state.deleteAiConversationMessageState = payload;
    },
    SET_EDIT_AI_CONVERSATION_MESSAGE(state, payload){
        state.editAiConversationMessageState = payload;
    },
    SET_CREATE_MOCK_AI_CONVERSATION(state, payload){
        state.createMockAiConversationState = payload;
    },
    ADD_TO_CREATE_MOCK_AI_CONVERSATION(state, payload){
        state.mockAiConversationData.push(payload);
    },
    RESET_CREATE_MOCK_AI_CONVERSATION(state){
        state.mockAiConversationData = [];
        state.createMockAiConversationState = apiBaseState();
    },
    SET_EVALUATE_AI_CONVERSATION(state, payload){
        state.evaluateAiConversationState = payload;
    },
};

function isQuestionPayload(payload) {
    return !!payload && typeof payload === 'object' && !Array.isArray(payload);
}

function normaliseQuestionContext(question) {
    if (!isQuestionPayload(question) || !question.id) {
        return null;
    }

    return {
        id: question.id,
        body: question.body || null,
        question_number: question.question_number ?? question.questionIds?.question_number ?? null,
    };
}

const getBase = ({ isGlobalAi, isQuestionLevel, isGlobalAiQuestionId }) => {
    if (isGlobalAi) {
        if (isGlobalAiQuestionId) {
            return `ai/${isGlobalAiQuestionId}`;
        }
        return 'ai';
    }
    if (isQuestionLevel) return 'ai';
    return 'insight-assist';
};

const getId = (state, rootState) => {
    const { isTaskLevel, isGlobalAi, isQuestionLevel, questionId, isGlobalAiQuestionId } = state;

    if (!isTaskLevel && !isGlobalAi) {
        return isQuestionLevel
            ? `/${questionId}`
            : `/${rootState.mediaAnalyser.currentRecord}`;
    }

    // When isGlobalAi and isGlobalAiQuestionId are true, we've already embedded questionId in base
    return '';
};

export const buildUrl = ({ state, rootState }) => {
    if (state.isVideoCall) {
        return `video-rooms/${state.meetingRoomId}/conversations`;
    }

    const base = getBase(state);
    const id = getId(state, rootState);

    return `${base}${id}/conversations`;
};

export const actions = {
    GET_AI_CONVERSATIONS(state, data) {
        const {accountSlug, projectSlug, taskSlug, apiQuery} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(state)}`;
        return this.$whyApi.get({
            url,
            params: apiQuery,
            mutation: "aiConversation/SET_AI_CONVERSATIONS",
            errorMessage: "Error getting conversations",
            notify: this.$notify
        });
    },
    UPDATE_AI_CONVERSATIONS(state, data) {
        const {accountSlug, projectSlug, taskSlug, conversationId,  ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(state)}/${conversationId}`;
        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "aiConversation/SET_UPDATE_AI_CONVERSATIONS",
            errorMessage: "Error updating conversation",
            notify: this.$notify
        });
    },
    GET_AI_CONVERSATION_MESSAGES(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(state)}/${payload.conversationId}/messages`;
        return this.$whyApi.get({
            url,
            mutation: "aiConversation/SET_AI_CONVERSATION_MESSAGES",
            errorMessage: "Error getting conversation messages",
            notify: this.$notify
        });
    },
    DELETE_AI_CONVERSATION_MESSAGE(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(state)}/${payload.conversationId}/messages/${payload.id}`;
        return this.$whyApi.delete({
            url,
            mutation: "aiConversation/SET_DELETE_AI_CONVERSATION_MESSAGE",
            errorMessage: "Error deleting conversation message",
            notify: this.$notify
        });
    },
    CREATE_AI_CONVERSATION_MESSAGE(context, data) {
        const useStream = true;
        const requestMethod = useStream ? 'stream' : 'post';
        const { accountSlug, projectSlug, taskSlug, apiQuery, tempConvId, ...payload } = data;
        const conversationId = payload.conversationId ? `/${payload.conversationId}` : '';
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(context)}${conversationId}/messages`;

        // Use a different mutation based on whether conversationId exists.
        const mutation = payload.conversationId
            ? 'aiConversation/UPDATE_AI_CONVERSATION'
            : 'aiConversation/SET_CREATE_AI_CONVERSATION_MESSAGE';

        return this.$whyApi[requestMethod]({
            url,
            data: { ...(apiQuery || {}), ...payload, ...(useStream && { stream: true }) },
            mutation,
            params: apiQuery,
            handleErrorLocally: true,
            errorMessage: "Error creating message",
            notify: false,
            ...(useStream && { handleStream: (streamPayload) => {
                    context.commit('STREAM_TO_CHOSEN_CHAT', { stream: streamPayload, tempConvId: data.tempConvId });
                } })
        });
    },
    UPDATE_AI_CONVERSATION_MESSAGE(context, data) {
        const useStream = true;
        const requestMethod = useStream ? 'stream' : 'put';
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(context)}/${payload.conversationId}/messages/${payload.id}`;
        return this.$whyApi[requestMethod]({
            url,
            data: {
                prompt: payload.prompt,
                ...(useStream && { stream: true })
            },
            mutation: 'aiConversation/SET_EDIT_AI_CONVERSATION_MESSAGE',
            handleErrorLocally: true,
            errorMessage: "Error updating message",
            notify: this.$notify,
            ...(useStream && { handleStream: (streamPayload) => {
                    context.commit('STREAM_TO_CHOSEN_CHAT', { stream: streamPayload, tempConvId: data.tempConvId });
                } })
        });
    },
    DELETE_AI_CONVERSATION(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}${taskSlug ? `/${taskSlug}` : ''}/${buildUrl(state)}/${payload.conversationId}`;
        return this.$whyApi.delete({
            url,
            data: payload,
            mutation: 'aiConversation/DELETE_AI_CONVERSATION',
            errorMessage: "Error deleting conversation",
            notify: this.$notify
        });
    },
    CREATE_MOCK_AI_CONVERSATION(context, data) {
        const {accountSlug, projectSlug, taskSlug, groupId, persona, signal, profile_group_ids} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/group/${groupId}/ai/mock-conversation/stream`;
        const useStream = true;
        return this.$whyApi.stream({
            url,
            mutation: 'aiConversation/SET_CREATE_MOCK_AI_CONVERSATION',
            errorMessage: "Error creating mock conversation",
            data: { persona, profile_group_ids, ...(useStream && { stream: true }) },
            signal,
            notify: false,
            ...(useStream && { handleStream: (streamPayload) => {
                    if(streamPayload){
                        context.commit('ADD_TO_CREATE_MOCK_AI_CONVERSATION', streamPayload);
                    }
                } })
        });
    },
    EVALUATE_AI_CONVERSATION(context, data) {
        const {accountSlug, projectSlug, taskSlug, groupId, persona, signal} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/group/${groupId}/ai/mock-conversation/evaluate`;
        return this.$whyApi.post({
            url,
            mutation: 'aiConversation/SET_EVALUATE_AI_CONVERSATION',
            errorMessage: "Error creating mock conversation",
            data: { persona },
            signal,
            notify: false,
        });
    },
};
